import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import {
    BrowserRouter as Router,useParams,
    Link,
} from "react-router-dom";
import { HeaderInterior } from '../HeaderInterior';
import { FaRegCommentDots,FaQuestion } from 'react-icons/fa'
import globals from 'react-global-configuration';
import { Container,Containertop, Containerpreguntas, Row,  Colseis, Coltres, Linkbtn,Txtinicio,DivPreguntas,Aviso,IconoAviso} from './styles'
import { OnAir } from '../OnAir';
import { PlayerVideo } from '../PlayerVideo';
import { Encuesta } from '../Encuesta';
import { ListaPatrocinadores } from '../ListaPatrocinadores';
import  EnDirecto  from '../EnDirecto';
import { ListOfResources } from '../ListOfResources';
import { FiAlertTriangle } from "react-icons/fi";




export const EventoInterior = (props) => {
   
    const [listSettings, setSettings] = useState(false);
    const [showPreguntar, setshowPreguntar] = useState(true);
    const [showEncuesta, setshowEncuesta] = useState(true);
    const _URL_REST = globals.get('_URL_REST')
    let { id } = useParams();
    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${id}`,
        );
        setSettings(result.data[0])
    };
  
    useEffect(() => {
        fetchSettings();
    },[]);

    const chageSetSettings = async () => {
        //console.log('listSettings',showPreguntar)
        if(showPreguntar){
            setshowPreguntar(false)
        }
        else{
            setshowPreguntar(true)
        }
    };

    const chageSetMostrarencuesta = async () => {
        if(showEncuesta){
            setshowEncuesta(false)
        }
        else{
            setshowEncuesta(true)
        }
    };

    const closeSetSettings = async () => {
        if(showPreguntar){
            setshowPreguntar(false)
        }
        else{
            setshowPreguntar(true)
        }
    };
    if(!listSettings) { return(<div></div>) }

    if(listSettings.eventoActivo){ 
        setTimeout(function(){
            //console.log('check again')
            fetchSettings();
        },30000);
        return (
            <Fragment>
            
                <HeaderInterior id={id} />
                <Containertop>
                    {listSettings.streaming === 1 ? 
                        <OnAir idevento={id} />
                    :
                        <PlayerVideo  idevento={id} />
                    }
                </Containertop>
                <div>
                    <Containerpreguntas>
                        
                        <div>
                            <div>
                            {listSettings.mostrarAviso === 1 && 
                                <Aviso>
                                    <IconoAviso><img className="patrocinador" src={`${process.env.PUBLIC_URL}/images/icon_aviso.png`} alt="" /></IconoAviso>
                                    <div dangerouslySetInnerHTML={{__html: listSettings.txtAviso}} />
                                </Aviso>
                            
                            }

                            {listSettings.mostrarPregunta != 0 ? 
                                <span>
                                <DivPreguntas dangerouslySetInnerHTML={{__html: listSettings.textoPreguntas}} />
                                <Linkbtn onClick={() => chageSetSettings()} className="btniconwithe">Preguntar | <FaRegCommentDots size="22" /></Linkbtn>
                                </span>
                            : ''  }

                            {listSettings.mostrarEncuesta != 0 ? 
                                <span>
                                <Linkbtn onClick={() => chageSetMostrarencuesta()} className="btniconwithe">Encuesta | <FaQuestion size="22" /></Linkbtn>
                                </span>
                                : ''  }
                            </div>

                            <div>
                            {listSettings.mostrarPregunta != 0 ? 
                                <span>
                                <EnDirecto idevento={id}  showdiv={showPreguntar} closeSetSettings={closeSetSettings}  />
                                </span>
                            : ''  }

                            {listSettings.mostrarEncuesta != 0 ? 
                                <span>
                                <Encuesta idevento={id}  showdiv={showEncuesta} closeSetSettings={closeSetSettings}  />
                                </span>
                                : ''  }
                            </div>
                            
                        </div>
                 
                    </Containerpreguntas> 
                </div>
                
                <Container> 
                    <Row>
                    {listSettings.mostrarRecursos === 1 && (
                        <Colseis>
                            <ListOfResources idevento={id} url='recursos' title='Recursos adicionales'  />
                        </Colseis>
                    )}
                    
                    </Row>
                </Container>
                {listSettings.mostrarPatrocinador === 1 && (
                    <Container>
                    <Row>
                        <Colseis>
                        <ListaPatrocinadores idevento={id}  />
                        </Colseis>
                    </Row>
                    </Container>
                )}
            </Fragment>
        )
    }else{
        setTimeout(function(){
            //console.log('check again')
            fetchSettings();
        },30000);
          
        return (
            <Fragment><HeaderInterior id={id} />
            <Container>
                    <Txtinicio>{listSettings.eventoActivoTXT}</Txtinicio>
                </Container></Fragment>)
    }
}